import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "social-links" }
const _hoisted_2 = ["href"]
const _hoisted_3 = {
  key: 0,
  class: "social-links__vertical-divider"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SocialLinks',
  props: {
  socials: {
    type: Array,
    required: true,
  },
},
  setup(__props) {

const props = __props;





return (_ctx: any,_cache: any) => {
  const _component_rich_text = _resolveComponent("rich-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.socials, (social, idx) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: social._uid
      }, [
        _createElementVNode("a", {
          class: "footer__social-link",
          target: "_blank",
          href: social.link.cached_url || social.link.url
        }, [
          _createVNode(_component_rich_text, {
            value: social.label
          }, null, 8, ["value"])
        ], 8, _hoisted_2),
        (idx < props.socials.length - 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}
}

})